import * as React from "react";

import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

interface SidePanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: "default" | "wide";
  className?: string;
}

const SidePanel = ({
  open,
  onOpenChange,
  title,
  subtitle,
  children,
  footer,
  width = "default",
  className,
}: SidePanelProps) => {
  const widthClass = width === "wide" ? "sm:max-w-[600px]" : "sm:max-w-md";

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className={cn(
          "w-full h-full bg-white p-0 flex flex-col",
          widthClass,
          className,
        )}
        side="right"
      >
        <SheetHeader className="p-6 border-b border-border flex-none">
          <SheetTitle className="text-xl font-semibold text-foreground">
            {title}
          </SheetTitle>
          {subtitle && (
            <SheetDescription className="text-sm text-muted-foreground">
              {subtitle}
            </SheetDescription>
          )}
        </SheetHeader>

        <div className="flex-1 min-h-0">
          <ScrollArea className="h-full">
            <div className="p-6">{children}</div>
          </ScrollArea>
        </div>

        {footer && (
          <div className="border-t border-border p-6 bg-white flex-none">
            {footer}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};

export { SidePanel };
